module.exports = __webpack_public_path__ + "img/tab-image-dancing-presentation.faf6bad0.png";